// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-chart-container .highcharts-title {
  font-weight: bold;
  font-size: 12px;
  fill: var(--filter-text-color);
  text-transform: unset;
}
#alert-chart-app .v-application--wrap {
  min-height: 0;
}
#alert-chart-app .highcharts-plot-line-label {
  font-family: var(--font-family);
  font-weight: 600;
  font-size: 9px;
  background-color: var(--panel-background);
}
.plot-band-critical {
  fill: var(--bad-color);
  fill-opacity: 0.25;
}
.plot-band-warn {
  fill: var(--fair-color);
  fill-opacity: 0.25;
}
.plot-band-info {
  fill: #0073b7;
  fill-opacity: 0.25;
}
.plot-line {
  stroke-width: 2px;
}
.plot-line-dashed {
  stroke-dasharray: 6;
}
.plot-line-dashed-solid {
  stroke-dasharray: 2;
}
.plot-line-critical {
  stroke: var(--bad-color);
}
.plot-line-warn {
  stroke: var(--fair-color);
}
.plot-line-info {
  stroke: #0073b7;
}
.plot-line-ne {
  stroke: #ffffff;
}
.plot-line-label-critical {
  padding: 0 3px;
  color: var(--bad-color);
  background-color: var(--panel-background);
}
.plot-line-label-warn {
  padding: 1px 3px;
  color: var(--fair-color);
  background-color: var(--panel-background);
}
.plot-line-label-info {
  padding: 1px 3px;
  color: var(--neutral-color);
  background-color: var(--panel-background);
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/moi-alert-chart/alertChart.vue","webpack://./alertChart.vue"],"names":[],"mappings":"AAEE;EACE,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;ACDJ;ADKA;EACE,aAAA;ACFF;ADKA;EACE,+BAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;ACFF;ADIA;EACE,uBAAA;EACA,kBAAA;ACDF;ADGA;EACE,aAAA;EACA,kBAAA;ACAF;ADGA;EACE,iBAAA;ACAF;ADEA;EACE,mBAAA;ACCF;ADCA;EACE,mBAAA;ACEF;ADAA;EACE,wBAAA;ACGF;ADDA;EACE,yBAAA;ACIF;ADFA;EACE,eAAA;ACKF;ADHA;EACE,eAAA;ACMF;ADJA;EACE,cAAA;EACA,uBAAA;EACA,yCAAA;ACOF;ADLA;EACE,gBAAA;EACA,wBAAA;EACA,yCAAA;ACQF;ADNA;EACE,gBAAA;EACA,2BAAA;EACA,yCAAA;ACSF","sourcesContent":["\n.alert-chart-container {\n  .highcharts-title {\n    font-weight: bold;\n    font-size: 12px;\n    fill: var(--filter-text-color);\n    text-transform: unset;\n  }\n}\n\n#alert-chart-app .v-application--wrap {\n  min-height: 0;\n}\n\n#alert-chart-app .highcharts-plot-line-label {\n  font-family: var(--font-family);\n  font-weight: 600;\n  font-size: 9px;\n  background-color: var(--panel-background);\n}\n\n.plot-band-critical {\n  fill: var(--bad-color);\n  fill-opacity: 0.25;\n}\n.plot-band-warn {\n  fill: var(--fair-color);\n  fill-opacity: 0.25;\n}\n.plot-band-info {\n  fill: #0073b7;\n  fill-opacity: 0.25;\n}\n\n.plot-line {\n  stroke-width: 2px;\n}\n.plot-line-dashed {\n  stroke-dasharray: 6;\n}\n.plot-line-dashed-solid {\n  stroke-dasharray: 2;\n}\n.plot-line-critical {\n  stroke: var(--bad-color);\n}\n.plot-line-warn {\n  stroke: var(--fair-color);\n}\n.plot-line-info {\n  stroke: #0073b7;\n}\n.plot-line-ne {\n  stroke: #ffffff;\n}\n.plot-line-label-critical {\n  padding: 0 3px;\n  color: var(--bad-color);\n  background-color: var(--panel-background);\n}\n.plot-line-label-warn {\n  padding: 1px 3px;\n  color: var(--fair-color);\n  background-color: var(--panel-background);\n}\n.plot-line-label-info {\n  padding: 1px 3px;\n  color: var(--neutral-color); // was #0073b7; 5.22:1 on white\n  background-color: var(--panel-background);\n}\n",".alert-chart-container .highcharts-title {\n  font-weight: bold;\n  font-size: 12px;\n  fill: var(--filter-text-color);\n  text-transform: unset;\n}\n\n#alert-chart-app .v-application--wrap {\n  min-height: 0;\n}\n\n#alert-chart-app .highcharts-plot-line-label {\n  font-family: var(--font-family);\n  font-weight: 600;\n  font-size: 9px;\n  background-color: var(--panel-background);\n}\n\n.plot-band-critical {\n  fill: var(--bad-color);\n  fill-opacity: 0.25;\n}\n\n.plot-band-warn {\n  fill: var(--fair-color);\n  fill-opacity: 0.25;\n}\n\n.plot-band-info {\n  fill: #0073b7;\n  fill-opacity: 0.25;\n}\n\n.plot-line {\n  stroke-width: 2px;\n}\n\n.plot-line-dashed {\n  stroke-dasharray: 6;\n}\n\n.plot-line-dashed-solid {\n  stroke-dasharray: 2;\n}\n\n.plot-line-critical {\n  stroke: var(--bad-color);\n}\n\n.plot-line-warn {\n  stroke: var(--fair-color);\n}\n\n.plot-line-info {\n  stroke: #0073b7;\n}\n\n.plot-line-ne {\n  stroke: #ffffff;\n}\n\n.plot-line-label-critical {\n  padding: 0 3px;\n  color: var(--bad-color);\n  background-color: var(--panel-background);\n}\n\n.plot-line-label-warn {\n  padding: 1px 3px;\n  color: var(--fair-color);\n  background-color: var(--panel-background);\n}\n\n.plot-line-label-info {\n  padding: 1px 3px;\n  color: var(--neutral-color);\n  background-color: var(--panel-background);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
